<template>
    <transition name="fade">
        <button
            v-if="showButton"
            class="rounded-full w-11 h-11 transition hover:bg-yellow-150 fixed right-4 lg:right-8 bottom-4 bg-yellow-100 flex items-center justify-center text-black scroll-to-top-btn text-2xl z-30"
            @click="scrollToTopOfThePage"
        >
            <i class="ri-arrow-up-s-line"></i>
        </button>
    </transition>
</template>

<script>
export default {
    name: 'ScrollToTopButton',
    data() {
        return {
            showButton: false,
        };
    },
    mounted() {
        if (typeof window !== 'undefined') {
            window.addEventListener('scroll', this.handleScroll);
        }
    },
    beforeDestroy() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('scroll', this.handleScroll);
        }
    },
    methods: {
        scrollToTopOfThePage() {
            if (typeof window !== 'undefined') {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth',
                });
            }
        },
        handleScroll() {
            if (typeof window !== 'undefined') {
                this.showButton = window.scrollY > 1500;
            }
        },
    },
};
</script>
